var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-8"},[_vm._l((_vm.faqs),function(faq){return _c('faq-item',{key:("faq-" + (faq.id)),attrs:{"faq":faq}})}),_c('lp-paginate',{attrs:{"filtered":_vm.faqFiltered},on:{"getData":_vm.getData}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }